<ng-container *transloco="let t">
  @for (tableDataRow of tableData;track tableDataRow.id!) {
    <div class="ps-3" @animate @animate [class.row-highlight]="tableDataRow.updated && fireAnimate"
         [class.row-move]="(tableDataRow.delta ?? false) && fireAnimate"
         [ngStyle]="{'--translate-value': tableDataRow.delta + '%'}">
          <div class="d-lg-none">
          <app-results-table-mobile-list-item [competitor]="tableDataRow.competitorResults"
                                                  [isRound]="isRoundRace ?? false"
                                                  [category]="category"
                                                  [gender]="gender" [measurementType]="measurementType"
                                                  [firstCompetitorResults]="firstCompetitorResults"
                                                  [isAdmin]="false"
                                                  [race]="race" [isLast]="$last"
                                                  (onOpenDetails)="openDetailsModal(tableDataRow.competitorResults, true)"
              ></app-results-table-mobile-list-item>
         </div>
    </div>
  }
  <div class="d-none d-lg-block">
    <div class="grid-table-box">
      <div class="grid-table" [ngClass]="{'cols-8': showCategories}">
        <div class="grid-header">
          <div class="grid-cell"><p class="medium">{{t('live.results.events.results.table.rank')}}</p></div>
          <div class="grid-cell"><p class="medium">{{t('competitor.table.start.number')}}</p></div>
          <div class="grid-cell"><p class="medium">{{t('app.common.name.surname')}}</p></div>
          @if (showCategories) {
          <div class="grid-cell">
            <p class="medium">{{t('competitor.table.category')}}</p>
          </div>
          }
          <div class="grid-cell"><p class="medium">{{t('competitor.table.club.team')}}</p></div>
          <div class="grid-cell"><p class="medium">{{t('live.results.events.results.table.time')}}</p></div>
          <div class="grid-cell"><p class="medium">{{t('live.results.events.results.table.gap')}}</p></div>
          <div class="grid-cell">
            <p class="medium">{{
                isRoundRace ?
                  t('live.results.events.results.table.laps') : t('live.results.events.results.table.controlPoints')
              }} </p>
          </div>
        </div>
        @for (liveResult of tableData;let idx = $index;track liveResult.id!) {
          <div class="grid-row" [class.result-border-bottom]="idx === 2 && isFullScreen">
            <div class="grid-cell" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                 [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                 [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
              <p>{{liveResult?.competitorResults | rank:category: gender :measurementType}}</p>
            </div>
            <div class="grid-cell" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                 [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                 [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
              <div class="start-number-badge" (click)="openDetailsModal(liveResult.competitorResults)">
                    {{liveResult.competitorResults?.startNumber ?? ""}}
                    <span class="ps-1">
                    <img src="assets/icons/icons-alt/search-list-02.svg" alt="Open details"/>
                  </span>
            </div>
            </div>
        <div class="grid-cell" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
              <p>{{
                  ((liveResult.competitorResults?.firstName ?? "")| titlecase) + " "
                  + ((liveResult.competitorResults?.lastName ?? "") | titlecase)
                }}</p>
            </div>
            @if (showCategories) {
             <div class="grid-cell" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                 [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                 [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
                    <p>{{liveResult.competitorResults?.categoryLabel ?? ""}}</p>
            </div>
            }
            <div class="grid-cell" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                 [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                 [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
              <p>{{liveResult.competitorResults?.club ?? ""}}</p>
            </div>
            <div class="grid-cell justify-content-center" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                 [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                 [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <p>{{liveResult.competitorResults?.competitorResultsDetail | resultsTotalTime:measurementType:raceSettings?.measurementPrecisionType}}</p>
                @if (!isRoundRace && liveResult.competitorResults?.competitorResultsDetail?.ltpCompetitorStageDetail) {
                  <p class="fs-12"
                  >{{liveResult.competitorResults?.competitorResultsDetail?.ltpCompetitorStageDetail|waypointNameByWaypointId}}</p>
                }
              </div>
            </div>
            <div class="grid-cell" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                 [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                 [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
              <p>{{liveResult.competitorResults?.competitorResultsDetail | resultsGapTime:firstCompetitorResults?.competitorResultsDetail:measurementType:raceSettings?.measurementPrecisionType}}</p>
            </div>
            <div class="grid-cell" @animate [class.row-highlight]="liveResult.updated && fireAnimate"
                 [class.row-move]="(liveResult.delta ?? false) && fireAnimate"
                 [ngStyle]="{'--translate-value': liveResult.delta + '%'}">
              <p>{{liveResult.competitorResults?.competitorResultsDetail | nmControlPointsOrLaps:isRoundRace}}</p>
            </div>
          </div>
        }
      </div>

      <div class="d-flex p-3 justify-content-center align-items-center">
        @if (!isFinished){
        <app-three-dots/>
        }
      </div>
    </div>
  </div>
</ng-container>
